import { t } from "ttag"
import moment from "moment-timezone"
import { SearchableSelectOption } from "@humanpredictiveintelligence/myqvt-library"

import { Theme } from "models/Theme"

export function getSelectOptionFromTheme(theme: Pick<Theme, "id" | "name" | "lastUsedAt">): SearchableSelectOption {
  return {
    description: theme.lastUsedAt
      ? t`Last used on ` + moment.parseZone(theme.lastUsedAt).format("Do MMMM")
      : "",
    label: theme.name,
    value: theme.id.toString(),
  }
}
